import { GUID, Param } from "app/brightserve/brightserve.module";

export class IncidentAdvice {
    Id: GUID;
    Author: string;
    Created: Date;
    Text: string;
    Status: Param;

    constructor(init?: Partial<IncidentAdvice>) {
        Object.assign(this, init);

        if (init && init.Status) {
            this.Status = new Param(init.Status);
        } else {
            this.Status = null;
        };
    }

    static BlankIncidentAdvice(init?: any) {
        var incidentAdvice = new IncidentAdvice(init);
        incidentAdvice.Id = GUID.newGuid();
        incidentAdvice.Status = new Param();
        return incidentAdvice;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/incident-advice.ts